import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => css`
    gap: ${theme.padding.smallest};
  `}
`;

export const ValuesContainer = styled.div`
  width: 100%;
  min-height: 40px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  ${({ theme }) => css`
    gap: ${theme.padding.smallest};
  `}
`;

export const ModalContainer = styled.div``;
